<script setup lang="ts">
import { computed } from 'vue'
import { NEmpty, NSpin } from 'naive-ui'
import type { MaterialGoods, MaterialResource } from '@/material/web/api'
import MaterialPreviewAssets from '@/material/web/MaterialPreviewAssets.vue'
import MaterialPreviewHalf from '@/material/web/MaterialPreviewHalf.vue'
import MaterialPreviewMusic from '@/material/web/MaterialPreviewMusic.vue'
import { isMusicCategory, shouldUseDollCompositePreview } from '@/material/web/previewUtils'

const props = defineProps<{
  goods: MaterialGoods | null
  resources: MaterialResource[]
  topCategoryId: string
  collected: boolean
  previewLoading: boolean
}>()

const emit = defineEmits<{
  toggleCollect: []
}>()

const previewKind = computed<'half' | 'music' | 'asset'>(() => {
  if (isMusicCategory(props.topCategoryId)) return 'music'
  if (shouldUseDollCompositePreview(props.topCategoryId, props.goods, props.resources)) {
    return 'half'
  }
  return 'asset'
})
</script>

<template>
  <div class="preview-host">
    <n-spin :show="previewLoading" class="preview-spin">
      <template v-if="goods">
        <MaterialPreviewHalf
          v-if="previewKind === 'half'"
          :key="`half-${goods.id}`"
          :goods="goods"
          :resources="resources"
          :top-category-id="topCategoryId"
          :collected="collected"
          :preview-loading="previewLoading"
          @toggle-collect="emit('toggleCollect')"
        />
        <MaterialPreviewMusic
          v-else-if="previewKind === 'music'"
          :key="`music-${goods.id}`"
          :goods="goods"
          :resources="resources"
          :top-category-id="topCategoryId"
          :collected="collected"
          :preview-loading="previewLoading"
          @toggle-collect="emit('toggleCollect')"
        />
        <MaterialPreviewAssets
          v-else
          :key="`asset-${goods.id}`"
          :goods="goods"
          :resources="resources"
          :top-category-id="topCategoryId"
          :collected="collected"
          :preview-loading="previewLoading"
          @toggle-collect="emit('toggleCollect')"
        />
      </template>
      <n-empty v-else description="请选择左侧素材查看详情" class="preview-empty" />
    </n-spin>
  </div>
</template>

<style scoped>
.preview-host,
.preview-spin {
  height: 100%;
  min-height: 0;
}

.preview-host {
  overflow: auto;
}

.preview-spin {
  overflow: visible;
}

.preview-spin :deep(.n-spin-content) {
  min-height: 100%;
  overflow: visible;
}

.preview-empty {
  height: 100%;
}
</style>
